/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import OutsideClickHandler from 'react-outside-click-handler';

import { SVGRender } from '../../../helper/image';
import CrossImg from '../../../assets/img/cross.svg';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { Wrapper } from './style';
import { MENU_MOBILE_BREAK_POINT } from './constants';

const Navigation = ({ categories }) => {
	const { width } = useWindowDimensions();
	const [sideShow, onSetShow] = useState(false);
	const [showCategory, onSetShowCategory] = useState(false);
	const isMobile = width > 0 && width <= MENU_MOBILE_BREAK_POINT;

	const isSideShow = isMobile && sideShow;
	const currentLocation = typeof window !== 'undefined' ? window.location.pathname : '';
	const splitLocation = currentLocation.split('/');
	const isHome = splitLocation[1] === 'blog' && !splitLocation[2] && !splitLocation[3];

	const activeCondition = slug => {
		if (splitLocation[2] === 'kategori' && splitLocation[3] === slug) {
			return 'nav-link active';
		}

		return 'nav-link';
	};

	const renderCategoryList = () => {
		if (categories.length <= 0) return <></>;

		return categories.map(val => {
			if (!val.node.title || !val.node.slug) return '';

			return (
				<Link to={`/blog/kategori/${val.node.slug}`} className={activeCondition(val.node.slug)}>
					{val.node.title}
				</Link>
			);
		});
	};

	const renderDropdownCategoryList = () => {
		const lists = categories.filter(val => val.node.slug !== 'portofolio');
		return (
			<div className="with-dropdown">
				<button
					type="button"
					onClick={() => {
						onSetShowCategory(!showCategory);
					}}
					className="nav-link"
				>
					Kategori
					<div className={showCategory ? 'arrow-down' : 'arrow-up'}>
						<ReactSVG src="https://seiturju.sirv.com/Chatbiz/arrow-up-black.svg" />
					</div>
				</button>
				<OutsideClickHandler
					onOutsideClick={() => {
						onSetShowCategory(false);
					}}
				>
					<div className={showCategory ? 'dropdown-wrapper show' : 'dropdown-wrapper hide'}>
						<ul>
							{lists.map(val => {
								return (
									<li>
										<Link to={`/blog/kategori/${val.node.slug}`} className={activeCondition(val.node.slug)}>
											{val.node.title}
										</Link>
									</li>
								);
							})}
						</ul>
					</div>
				</OutsideClickHandler>
			</div>
		);
	};

	return (
		<Wrapper>
			<div className={isMobile && sideShow ? 'overlay active' : 'overlay'} />

			<nav className="navbar navbar-expand-md navbar-light fixed-top">
				<div className="container">
					<Link to="/blog" className="navbar-brand">
						{SVGRender(
							'https://seiturju.sirv.com/Chatbiz/chatbiz-blog-logo-vec.svg',
							'',
							'',
							'',
							'Logo Chatbiz Blog',
							false,
							false,
						)}
					</Link>

					<button
						type="button"
						className="navbar-toggler"
						onClick={() => {
							onSetShow(true);
						}}
					>
						<img
							alt=""
							src="https://seiturju.sirv.com/Chatbiz/burger.svg"
							className="img-fluid g-image"
						/>
					</button>

					<div
						className={isSideShow ? 'collapse navbar-collapse showSideMenu' : 'collapse navbar-collapse'}
						id="navbarCollapse"
					>
						{isMobile && (
							<div className="menuMobile">
								<div>Menu</div>
								<button
									type="button"
									onClick={() => {
										onSetShow(false);
									}}
								>
									<img src={CrossImg} alt="CrossImg" />
								</button>
							</div>
						)}
						<div className="navbar-nav ml-auto">
							<a href="/" target="__blank" className="nav-link">
								Chatbiz
							</a>
							<Link to="/blog" className={isHome ? 'nav-link active' : 'nav-link'}>
								Blog
							</Link>
							{!isMobile && (
								<Link to="/blog/kategori/portofolio" className={activeCondition('portofolio')}>
									Portofolio
								</Link>
							)}

							{isMobile ? renderCategoryList() : renderDropdownCategoryList()}
						</div>
					</div>
				</div>
			</nav>
		</Wrapper>
	);
};

Navigation.propTypes = {
	categories: PropTypes.arrayOf(PropTypes.object),
};

export default Navigation;
